import {
  LayoutDashboard,
  LineChart,
  Bell,
  Building2,
  Users,
  CreditCard,
  Database,
  Settings,
  LifeBuoy,
  GraduationCap,
  SlidersHorizontal,
  ClipboardList,
  UserCheck,
  FileCheck,
  Lock,
  UserRoundSearch,
  Archive,
  Flag,
  Briefcase,
  UsersRound,
  ScanFace,
  ScrollText,
  Library,
} from "lucide-react";

/** Base path for authenticated app routes (HashRouter paths). */
export const APP_BASE = "/app";

/** Profile sub-route for candidate / employee assigned assessments. */
export const PROFILE_ASSESSMENTS_PATH = `${APP_BASE}/profile/assessments`;

/** Client nav catalog — keys must match backend permissions/catalog.js */
export const NAV_SECTIONS = [
  {
    id: "home",
    label: "Home",
    sectionKey: "section.home",
    items: [
      { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/app/dashboard", navKey: "nav.dashboard", routeKey: "route.dashboard.dashboard" },
      { id: "pendingApprovals", label: "Pending Approvals", icon: FileCheck, path: "/app/pending-approvals", navKey: "nav.pendingApprovals", routeKey: "route.dashboard.pendingApprovals" },
      { id: "notifications", label: "Notifications", icon: Bell, path: "/app/notifications", navKey: "nav.notifications", routeKey: "route.dashboard.notifications" },
      { id: "analytics", label: "Analytics", icon: LineChart, path: "/app/analytics", navKey: "nav.analytics", routeKey: "route.dashboard.analytics" },
    ],
  },
  {
    id: "adminTools",
    label: "Content Library",
    sectionKey: "section.adminTools",
    items: [
      { id: "banks", label: "Question Bank", icon: Database, path: "/app/banks", navKey: "nav.banks", routeKey: "route.dashboard.banks" },
      { id: "evalrisQuestionBanks", label: "Evalris Question Banks", icon: Library, path: "/app/evalris-question-banks", navKey: "nav.evalrisQuestionBanks", routeKey: "route.dashboard.evalrisQuestionBanks" },
      { id: "assessments", label: "Assessment Bank", icon: ClipboardList, path: "/app/assessments", navKey: "nav.assessments", routeKey: "route.dashboard.assessments" },
    ],
  },
  {
    id: "examCenter",
    label: "Administration Center",
    sectionKey: "section.examCenter",
    items: [
      { id: "assessmentCycles", label: "Assessment Cycle", icon: GraduationCap, path: "/app/administration-center/assessment-cycles", navKey: "nav.assessmentCycles", routeKey: "route.dashboard.assessmentCycles" },
      { id: "assessmentSequence", label: "Assessment Sequence", icon: SlidersHorizontal, path: "/app/administration-center/assessment-sequence", navKey: "nav.assessmentSequence", routeKey: "route.dashboard.assessmentSequence" },
      { id: "archivedCycles", label: "Archived Cycles", icon: Archive, path: "/app/administration-center/archived-cycles", navKey: "nav.archivedCycles", routeKey: "route.dashboard.archivedCycles" },
    ],
  },
  {
    id: "results",
    label: "Results",
    sectionKey: "section.results",
    items: [
      { id: "resultsAnalytics", label: "Results & Analytics", icon: FileCheck, path: "/app/administration-center/results-analytics", navKey: "nav.resultsAnalytics", routeKey: "route.dashboard.resultsAnalytics" },
      { id: "redFlags", label: "Red Flags", icon: Flag, path: "/app/administration-center/red-flags", navKey: "nav.redFlags", routeKey: "route.dashboard.redFlags" },
    ],
  },
  {
    id: "candidateManagement",
    label: "Candidate Management",
    sectionKey: "section.candidateManagement",
    items: [
      {
        id: "candidates",
        label: "Candidates",
        icon: UserRoundSearch,
        path: "/app/candidates",
        navKey: "nav.candidates",
        routeKey: "route.dashboard.candidates",
      },
      {
        id: "candidateGroups",
        label: "Candidate Groups",
        icon: UsersRound,
        path: "/app/candidate-groups",
        navKey: "nav.candidateGroups",
        routeKey: "route.dashboard.candidateGroups",
      },
    ],
  },
  {
    id: "jobs",
    label: "Jobs",
    sectionKey: "section.jobs",
    items: [
      {
        id: "jobs",
        label: "Jobs",
        icon: Briefcase,
        path: "/app/jobs",
        navKey: "nav.jobs",
        routeKey: "route.dashboard.jobs",
      },
    ],
  },
  {
    id: "Interviews",
    label: "Interviews",
    sectionKey: "section.interviews",
    items: [
      { id: "FaceInterview", label: "Face Interview (Beta)", icon: ScanFace, path: "/app/face-interview", navKey: "nav.faceInterview", routeKey: "route.dashboard.faceInterview" },
    ],
  },
  {
    id: "management",
    label: "Management",
    sectionKey: "section.management",
    items: [
      { id: "organization", label: "Organization", icon: Building2, path: "/app/organization", navKey: "nav.organization", routeKey: "route.dashboard.organization" },
      { id: "users", label: "Users & Roles", icon: Users, path: "/app/users", navKey: "nav.users", routeKey: "route.dashboard.users" },
      { id: "accessControl", label: "Access Control", icon: Lock, path: "/app/access-control", navKey: "nav.accessControl", routeKey: "route.dashboard.accessControl" },
      { id: "userApprovals", label: "User Approvals", icon: UserCheck, path: "/app/user-approvals", navKey: "nav.userApprovals", routeKey: "route.dashboard.userApprovals" },
      { id: "auditLogs", label: "Audit Logs", icon: ScrollText, path: "/app/audit-logs", navKey: "nav.auditLogs", routeKey: "route.auditLogs.view" },
    ],
  },
  {
    id: "system",
    label: "System Controls",
    sectionKey: "section.system",
    items: [
      { id: "subscription", label: "Subscription", icon: CreditCard, path: "/app/subscription", navKey: "nav.subscription", routeKey: "route.dashboard.subscription" },
      { id: "storage", label: "Storage", icon: Database, path: "/app/storage", navKey: "nav.storage", routeKey: "route.dashboard.storage" },
      { id: "settings", label: "Settings", icon: Settings, path: "/app/settings", navKey: "nav.settings", routeKey: "route.dashboard.settings" },
      { id: "support", label: "Support", icon: LifeBuoy, path: "/app/support", navKey: "nav.support", routeKey: "route.dashboard.support" },
    ],
  },
];

export const ROUTE_PERMISSION_FALLBACKS = [
  { match: (p) => p.startsWith("/app/bank/") && p.endsWith("/questions"), routeKey: "route.dashboard.bankQuestions" },
  {
    match: (p) => /^\/app\/evalris-question-banks\/[^/]+\/questions$/.test(p),
    routeKey: "route.dashboard.evalrisQuestionBankQuestions",
  },
  {
    match: (p) => /^\/app\/assessments\/[^/]+\/edit-questions$/.test(p),
    routeKey: "route.dashboard.editAssessmentQuestions",
  },
  {
    match: (p) => /^\/app\/assessments\/[^/]+\/review$/.test(p),
    routeKey: "route.dashboard.reviewAssessment",
  },
  {
    match: (p) => /^\/app\/assessments\/[^/]+\/history$/.test(p),
    routeKey: "route.dashboard.assessmentHistory",
  },
  {
    match: (p) => /^\/app\/administration-center\/assessment-cycles\/[^/]+$/.test(p),
    routeKey: "route.dashboard.assessmentCycleDetail",
  },
  { match: (p) => p === "/app/create-assessment", routeKey: "route.dashboard.createAssessment" },
  { match: (p) => p === "/assessment-exam", routeKey: "route.assessmentExam" },
  { match: (p) => p === PROFILE_ASSESSMENTS_PATH, routeKey: "route.dashboard.home" },
  { match: (p) => p === "/app/home", routeKey: "route.dashboard.home" },
  { match: (p) => /^\/app\/users\/[^/]+$/.test(p), routeKey: "route.dashboard.userDetail" },
  { match: (p) => /^\/app\/admins\/[^/]+$/.test(p), routeKey: "route.dashboard.userDetail" },
  { match: (p) => /^\/app\/candidates\/[^/]+$/.test(p), routeKey: "route.dashboard.candidateDetail" },
  {
    match: (p) => p === "/app/candidate-groups" || /^\/app\/candidate-groups\/[^/]+$/.test(p),
    routeKey: "route.dashboard.candidateGroups",
  },
  { match: (p) => p === "/app/audit-logs", routeKey: "route.auditLogs.view" },
  { match: (p) => p === "/app/evalris/audit-logs", routeKey: "route.auditLogs.view" },
  { match: (p) => p === "/app/jobs" || /^\/app\/jobs\/[^/]+$/.test(p), routeKey: "route.dashboard.jobs" },
];

export function resolveRoutePermissionKey(pathname) {
  const path = pathname.split("?")[0].replace(/\/$/, "") || "/";
  for (const rule of ROUTE_PERMISSION_FALLBACKS) {
    if (rule.match(path)) return rule.routeKey;
  }
  for (const section of NAV_SECTIONS) {
    for (const item of section.items) {
      if (item.path === path) return item.routeKey;
    }
  }
  return null;
}

export function firstAllowedRoutePath(can) {
  for (const section of NAV_SECTIONS) {
    if (!can(section.sectionKey)) continue;
    for (const item of section.items) {
      if (can(item.navKey) && can(item.routeKey)) return item.path;
    }
  }
  return null;
}

/** Default landing page when permissions are still loading or route-specific access is denied. */
export function defaultDashboardPathForRole(role) {
  switch (String(role || "").toUpperCase()) {
    case "EVALRIS":
      return `${APP_BASE}/evalris`;
    case "SUPER_ADMIN":
      return `${APP_BASE}/dashboard`;
    case "ADMIN":
      return `${APP_BASE}/users`;
    case "HR_ADMIN":
      return `${APP_BASE}/assessments`;
    case "EMPLOYEE":
    case "CANDIDATE":
    case "USER":
      return `${APP_BASE}/profile`;
    default:
      return `${APP_BASE}/profile`;
  }
}

/**
 * Resolve the dashboard URL for the signed-in user.
 * Role takes precedence over permission nav order (EVALRIS bypass would otherwise
 * match every nav item and land on super-admin /app/dashboard).
 */
export function resolvePostLoginPath(can, role, { isEvalrisOperator = false } = {}) {
  const normalizedRole = String(role || "").toUpperCase();
  if (isEvalrisOperator || normalizedRole === "EVALRIS") {
    return `${APP_BASE}/evalris`;
  }
  if (normalizedRole === "USER" || normalizedRole === "CANDIDATE") {
    return `${APP_BASE}/profile`;
  }
  if (normalizedRole === "EMPLOYEE") {
    return `${APP_BASE}/profile`;
  }
  if (normalizedRole === "HR_ADMIN") {
    return firstAllowedRoutePath(can) || `${APP_BASE}/assessments`;
  }
  if (normalizedRole === "ADMIN") {
    return firstAllowedRoutePath(can) || `${APP_BASE}/users`;
  }
  if (normalizedRole === "SUPER_ADMIN") {
    return firstAllowedRoutePath(can) || `${APP_BASE}/dashboard`;
  }
  return firstAllowedRoutePath(can) || defaultDashboardPathForRole(role);
}

/** Map legacy URLs to unified app paths */
export function legacyPathRedirect(pathname) {
  const map = {
    "/dashboard/interloop": `${APP_BASE}/dashboard`,
    "/dashboard/interloop/dashboard": `${APP_BASE}/dashboard`,
    "/dashboard/interloop/notifications": `${APP_BASE}/notifications`,
    "/dashboard/interloop/analytics": `${APP_BASE}/analytics`,
    "/dashboard/interloop/exam-center/exams": `${APP_BASE}/exam-center/exams`,
    "/dashboard/interloop/exam-center/roster": `${APP_BASE}/exam-center/roster`,
    "/dashboard/interloop/exam-center/controls": `${APP_BASE}/exam-center/controls`,
    "/dashboard/interloop/exam-center/feedback": `${APP_BASE}/exam-center/feedback`,
    "/dashboard/interloop/organization": `${APP_BASE}/organization`,
    "/dashboard/interloop/users": `${APP_BASE}/users`,
    "/dashboard/interloop/admins": `${APP_BASE}/users`,
    "/dashboard/interloop/subscription": `${APP_BASE}/subscription`,
    "/dashboard/interloop/storage": `${APP_BASE}/storage`,
    "/dashboard/interloop/settings": `${APP_BASE}/settings`,
    "/dashboard/interloop/support": `${APP_BASE}/support`,
    "/dashboard/admin": `${APP_BASE}/banks`,
    "/dashboard/admin/banks": `${APP_BASE}/banks`,
    "/dashboard/admin/assessments": `${APP_BASE}/assessments`,
    "/dashboard/admin/users": `${APP_BASE}/user-approvals`,
    "/dashboard/admin/submissions": `${APP_BASE}/administration-center/results-analytics`,
    "/dashboard/admin/create-assessment": `${APP_BASE}/create-assessment`,
    "/dashboard/user": PROFILE_ASSESSMENTS_PATH,
  };
  if (map[pathname]) return map[pathname];
  if (pathname.startsWith("/dashboard/interloop/")) {
    return pathname.replace("/dashboard/interloop", APP_BASE);
  }
  if (pathname.startsWith("/dashboard/admin/")) {
    const next = pathname.replace("/dashboard/admin", APP_BASE);
    if (next === `${APP_BASE}/users`) return `${APP_BASE}/user-approvals`;
    return next;
  }
  if (pathname === "/dashboard") return APP_BASE;
  if (pathname.startsWith("/dashboard/")) {
    return pathname.replace("/dashboard", APP_BASE);
  }
  const bankMatch = pathname.match(/^\/bank\/([^/]+)\/questions$/);
  if (bankMatch) return `${APP_BASE}/bank/${bankMatch[1]}/questions`;
  return null;
}
